import Loadable from "../utils/loadable";

export const Navigation = Loadable(() =>
  import(/* webpackChunkName: "Navigation" */ "./Navigation/Navigation")
);

// Product Group

export const ProductGroup = Loadable(() =>
  import(/* webpackChunkName: "ProductGroups" */ "./ProductGroup/ProductGroup")
);

export const ProductGroupAdd = Loadable(() =>
  import(
    /* webpackChunkName: "productgroups/add" */ "./ProductGroup/ProductGroupDetails/ProductGroupAdd"
  )
);

export const ProductGroupEdit = Loadable(() =>
  import(
    /* webpackChunkName: "productgroups/edit/[index]" */ "./ProductGroup/ProductGroupDetails/ProductGroupEdit"
  )
);

// Products

export const Products = Loadable(() =>
  import(/* webpackChunkName: "Products" */ "./Products/Products")
);

export const ProductsEdit = Loadable(() =>
  import(
    /* webpackChunkName: "products/edit/[index]" */ "./Products/ProductDetails/ProductsEdit"
  )
);

export const ProductsAdd = Loadable(() =>
  import(
    /* webpackChunkName: "products/add" */ "./Products/ProductDetails/ProductsAdd"
  )
);

// Combos

export const Combos = Loadable(() =>
  import(/* webpackChunkName: "Combos" */ "./Combos/Combos")
);

export const ComboDetails = Loadable(() =>
  import(
    /* webpackChunkName: "combos/details/[index]" */ "./Combos/ComboDetails/ComboDetails"
  )
);

export const CombosAdd = Loadable(() =>
  import(
    /* webpackChunkName: "combos/details/[index]" */ "./Combos/ComboDetails/CombosAdd"
  )
);

// File Approvals

export const FileApprovals = Loadable(() =>
  import(
    /* webpackChunkName: "File Approvals" */ "./FileApprovals/FileApprovals"
  )
);

// Key Pos

export const KeyPos = Loadable(() =>
  import(/* webpackChunkName: "KeyPos" */ "./KeyPos/KeyPos")
);

export const PosDecentralized = Loadable(() =>
  import(
    /* webpackChunkName: "Pos Decentralized" */ "./PosDecentralized/PosDecentralized"
  )
);

export const Survey = Loadable(() =>
  import(/* webpackChunkName: "Pos Survey" */ "./Survey/Survey")
);

// Geo Tree

export const GeoTree = Loadable(() =>
  import(/* webpackChunkName: "GeoTree" */ "./GeoTree/GeoTree")
);

export const GeoTreeEdit = Loadable(() =>
  import(/* webpackChunkName: "GeoTreeEdit" */ "./GeoTree/GeoTreeDetails/GeoTreeEdit")
);

export const GeoTreeAdd = Loadable(() =>
  import(
    /* webpackChunkName: "GeoTreeAdd/add" */ "./GeoTree/GeoTreeDetails/GeoTreeAdd"
  )
);

// Ezds

export const Ezds = Loadable(() =>
  import(/* webpackChunkName: "Ezds" */ "./Ezd/Ezds")
);

export const EzdDetails = Loadable(() =>
  import(/* webpackChunkName: "EzdDetails" */ "./Ezd/EzdDetails/EzdDetails")
);

export const EzdBranchAdd = Loadable(() =>
  import(
    /* webpackChunkName: "EzdBranchAdd" */ "./Ezd/EzdDetails/EzdBranch/EzdBranchAdd"
  )
);

export const EzdBranchEdit = Loadable(() =>
  import(
    /* webpackChunkName: "EzdBranchEdit" */ "./Ezd/EzdDetails/EzdBranch/EzdBranchEdit"
  )
);

export const SelloutFileApprovals = Loadable(() =>
  import(
    /* webpackChunkName: "SelloutFileApprovals" */ "./Sellout/FileApprovals/FileApprovals"
  )
);

export const ValidationRules = Loadable(() =>
  import(
    /* webpackChunkName: "ValidationRules" */ "./ValidationRules/ValidationRules"
  )
);

export const ValidationRulesEdit = Loadable(() =>
  import(
    /* webpackChunkName: "ValidationRulesEdit" */ "./ValidationRules/ValidationRulesDetails/ValidationRulesEdit"
  )
);

export const SelloutFileSubmission = Loadable(() =>
  import(
    /* webpackChunkName: "SelloutFileSubmission" */ "./Sellout/FileSubmission/FileSubmission"
  )
);